// extracted by mini-css-extract-plugin
module.exports = {"root":"rdg_f1048740","link":"rdg_15727a63","imageContainer":"rdg_74f61b15","storyImage":"rdg_8c09e311","storyLabel":"rdg_c711d437 rdg_09d341fe"};